import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteService } from 'src/app/core/services/route.service';
import * as moment from 'moment';

@Component({
  selector: 'app-upsert-event',
  templateUrl: './upsert-event.component.html',
  styleUrls: ['./upsert-event.component.scss'],
})
export class UpsertEventComponent implements OnInit {
  @Input('inputEvent') inputEvent: any;
  @Input('tableId') tableId: any;
  @Input('reportsData') reportsData: any;
  constructor(
    private modal: NgbModal,
    private fb: UntypedFormBuilder,
    private route: RouteService
  ) {}
  form!: UntypedFormGroup;
  editLink: string = '';
  ngOnInit(): void {
    this.initForm();
    this.setValues();
    this.editLink = `apps/${this.route.getApplicationKey()}/tables/${
      this.tableId
    }/reports/datatable/view/${this.reportsData.Key}/details/${
      this.inputEvent.id
    }`;
  }

  /**
   * Close modal
   */
  close = () => {
    this.modal.dismissAll();
  };

  /**
   * Init form
   */
  initForm = () => {
    this.form = this.fb.group({
      Id: [null],
      Name: [null],
      EventStart: [null],
      EventEnd: [null],
      EventAllDay: [false],
    });
  };

  setValues = () => {
    this.form.controls['Id'].setValue(this.inputEvent.id);
    this.form.controls['Name'].setValue(this.inputEvent.title.split(' - ')[0]);
    this.form.controls['EventStart'].setValue(
      moment(this.inputEvent.start, 'MM-DD-yyyy HH:mm:ss').format(
        'YYYY-MM-DDTHH:mm'
      )
    );
    this.inputEvent.showEndDate
      ? this.form.controls['EventEnd'].setValue(
          moment(this.inputEvent.end, 'MM-DD-yyyy HH:mm:ss').format(
            'YYYY-MM-DDTHH:mm'
          )
        )
      : this.form.controls['EventEnd'].setValue(' ');
    this.form.controls['EventAllDay'].setValue(this.inputEvent.allDay);
  };

  isDateNull(date: Date) {
    return moment(date).diff(new Date('0001-01-01T00:00:00')) === 0;
  }
}
